module.exports = __webpack_public_path__ + "img/upcommingvisits.2076a0e1.png";